import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5223b7f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { class: "box mark" }
const _hoisted_5 = { class: "high-light" }
const _hoisted_6 = { class: "high-light" }
const _hoisted_7 = { class: "high-light" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))

import { ref, reactive, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { CellGroup, Cell, Overlay, Loading, showFailToast } from "vant";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";
import { numToMoney } from "@/utils";

import request from "@/provide/fetch";

export default /*#__PURE__*/_defineComponent({
  __name: 'CentralArea',
  setup(__props) {

const route = useRoute();

const visible = ref(false);
const pageData = ref<any>({});
const getPageData = async () => {
  const res = await request({
    url: `/api/wx/invoice/list-center-returned`,
    method: "POST",
    data: {
      dept: route.params.center,
      openId: sessionStorage.getItem("openid"),
      startDay: dayjs(route.params.time as any).format("YYYY-MM-DD"),
      endDay: dayjs(route.params.time as any).format("YYYY-MM-DD"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    pageData.value = res.data;
    visible.value = true;
  } else {
    showFailToast(res.data);
  }
};
getPageData();

const getUserInfo = async () => {
  return request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  }).then((res) => {
    if (res.code === 200) {
      sessionStorage.setItem("name", res.data.name);
    }
  });
};
onMounted(() => {
  document.title = `${route.params.center}酬金回款情况`;
  if (sessionStorage.getItem("name")) {
    createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
  } else {
    getUserInfo().then(() => {
      createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(pageData.value.time).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(CellGroup), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Cell), {
              size: "large",
              title: `${_unref(route).params.center}总应收:`,
              class: "bold"
            }, {
              value: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(numToMoney)(pageData.value.receivableAmount)), 1)
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(_unref(Cell), {
              size: "large",
              title: "本年度累计开票",
              class: "bold"
            }, {
              value: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(numToMoney)(pageData.value.currYearInvoiceAmount)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Cell), {
              size: "large",
              title: "本年度累计回款",
              class: "bold"
            }, {
              value: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(numToMoney)(pageData.value.currYearReturnedAmount)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_8,
        _createVNode(_unref(CellGroup), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Cell), {
              title: "本月开票合计",
              value: _unref(numToMoney)(pageData.value.currMonthInvoiceAmount)
            }, null, 8, ["value"]),
            _createVNode(_unref(Cell), {
              title: "本月回款",
              value: _unref(numToMoney)(pageData.value.currMonthReturnedAmount)
            }, null, 8, ["value"])
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})